import { render } from "./CInfoRow.vue?vue&type=template&id=60020548&scoped=true&ts=true"
import script from "./CInfoRow.vue?vue&type=script&lang=ts"
export * from "./CInfoRow.vue?vue&type=script&lang=ts"

import "./CInfoRow.vue?vue&type=style&index=0&id=60020548&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60020548"]])

export default __exports__